export default __webpack_public_path__ + "static/media/error.297c1607.gif";